const initialUserStore = {};

export default initialUserStore;
